import { render, staticRenderFns } from "./PopupPreview.vue?vue&type=template&id=47027324&scoped=true&"
import script from "./PopupPreview.vue?vue&type=script&lang=js&"
export * from "./PopupPreview.vue?vue&type=script&lang=js&"
import style0 from "./PopupPreview.vue?vue&type=style&index=0&id=47027324&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47027324",
  null
  
)

export default component.exports